<template>
    <div class="checkout_success">
        <div>
            <img class='success_img' src="@/assets/img/checkoutSuccess.png" />
            <p class='success_txt'>下单成功</p>
        </div>
        <div class='success_information'>
            <p>商户信息</p>
            <p>{{$route.query.information}}</p>
        </div>
        <p class='success_tips'>如遇支付问题，请致电会引擎客服热线</p>
    </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
           
        };
    },
   created(){
        // 禁用返回
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL);
    });
   }
};
</script>
<style scoped lang="scss">
    .checkout_success{
        width: 100%;
        height: 100%;
        padding-top: 20%;
        div:first-child{
            text-align: center;
            font-size: .2rem;
            margin-bottom: 5%;
            .success_img{
                width: 28%;
            }
            .success_txt{
                color: var(--themeColor);
                font-weight: 500;
            }
        }
        .success_information{
            width: 80%;
            font-size: .16rem;
            display: flex;
            margin: 0 auto;
            line-height: .4rem;
            padding-bottom: .15rem;
            border-bottom: 1px solid #cdc6c6;
            p:first-child{
                color: #969799;
                width: 35%;
            }
            p{
                width: 65%;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
            }
            p:last-child{
                text-align: right;
            }
        }
        .success_tips{
            padding-top: .25rem;
            text-align: center;
            font-size: .14rem;
            color: #969799;
        }
    }
    
</style>